export const getVetifyApiTokenApi = (data) => {
    return {
      type: 'GET_VERIFY',
      payload: data,
    };
  };